// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"1a67976f","455":"d084bb9d"}[chunkId] + ".chunk.js";
};